import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SystemAlert, SystemAlertCreateOrUpdateCommand } from '../model/system-alert';
import { Injectable } from '@angular/core';

@Injectable()
export class SystemAlertService {
  private readonly baseUrl = `${environment.serverUrl}api/system-alerts`;

  constructor(private http: HttpClient) { }

  fetchActive(): Observable<SystemAlert[]> {
    return this.http.get<SystemAlert[]>(`${this.baseUrl}/active`);
  }

  fetchAll(): Observable<SystemAlert[]> {
    return this.http.get<SystemAlert[]>(this.baseUrl);
  }

  save(systemAlert: SystemAlert): Observable<string> {
    const command: SystemAlertCreateOrUpdateCommand = {
      title: systemAlert.title,
      body: systemAlert.body,
      type: systemAlert.type,
      displayFrom: systemAlert.displayFrom,
      displayTo: systemAlert.displayTo,
      active: systemAlert.active
    };
    if (systemAlert.id != null) {
      return this.http.put<string>(`${this.baseUrl}/${versionedId(systemAlert)}`, command);
    }
    return this.http.post<string>(this.baseUrl, command);
  }

  delete(systemAlert: SystemAlert): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${versionedId(systemAlert)}`);
  }
}

function versionedId(systemAlert: SystemAlert): string {
  return `${systemAlert.id}:${systemAlert.version}`;
}
